module.exports = __webpack_public_path__ + "img/snacks-table-icon.70841bf4.svg";